import moment from 'moment';

import { DATE_FORMAT, LONG_DATE_FORMAT } from './constants';

export function dateCellRenderer(value: string, longDate = false) {
  return value
    ? moment(value).format(longDate ? LONG_DATE_FORMAT : DATE_FORMAT)
    : '';
}
